import { getCurrentSystem, SYSTEM_TYPE } from '@umu/ukit-lang';

const getDefaultAvatars = (): [string, string] => {
    const system = getCurrentSystem();
    switch (system) {
        case SYSTEM_TYPE.CN:
            return [
                'https://statics-cdn-cn.umucdn.cn/statics/assessment/common/default-avatar-1.png',
                'https://statics-cdn-cn.umucdn.cn/statics/assessment/common/default-avatar-2.png',
            ];
        case SYSTEM_TYPE.JP:
            return [
                'https://dpfrzbu0cqnmm.cloudfront.net/statics/assessment/common/default-avatar-1.png',
                'https://dpfrzbu0cqnmm.cloudfront.net/statics/assessment/common/default-avatar-2.png',
            ];
        case SYSTEM_TYPE.EM:
        case SYSTEM_TYPE.EN:
            return [
                'https://d1bvk99i2a79wx.cloudfront.net/statics/assessment/common/default-avatar-1.png',
                'https://d1bvk99i2a79wx.cloudfront.net/statics/assessment/common/default-avatar-2.png',
            ];
        case SYSTEM_TYPE.TW:
            return [
                'https://d1yemi1ss2f2oh.cloudfront.net/statics/assessment/common/default-avatar-1.png',
                'https://d1yemi1ss2f2oh.cloudfront.net/statics/assessment/common/default-avatar-2.png',
            ];
        default:
            return [
                'https://statics-cdn-cn.umucdn.cn/statics/assessment/common/default-avatar-1.png',
                'https://statics-cdn-cn.umucdn.cn/statics/assessment/common/default-avatar-2.png',
            ];
    }
};

const defaultAvatars = getDefaultAvatars();

export { defaultAvatars };
